<template>
    <div>
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            min-width="auto"
            offset-y>

            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    outlined
                    hide-details
                    readonly
                    clearable
                    append-icon="mdi-calendar"
                    :value="dateTimeRangeText"
                    :height="height"
                    :placeholder="$t('placeholder.dateTimeRange')"
                    :style="{ minWidth: '320px' }"
                    v-on="on"
                    v-bind="attrs"
                    @click:clear="onDateTimeRangeClear"/>
            </template>

            <v-card>
                <v-container>
                    <!-- Start Date Picker -->
                    <v-row>
                        <v-col cols="6">
                            <v-date-picker v-model="startDate" color="primary"></v-date-picker>
                        </v-col>
                        <v-col cols="6">
                            <v-time-picker v-model="startTime" format="24hr" color="primary"></v-time-picker>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <!-- End Date Picker -->
                    <v-row>
                        <v-col cols="6">
                            <v-date-picker v-model="endDate" color="primary"></v-date-picker>
                        </v-col>
                        <v-col cols="6">
                            <v-time-picker v-model="endTime" format="24hr" color="primary"></v-time-picker>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="red" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="saveDateTimeRange">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
    name: 'DateTimeRangeField',

    props: {
        value: {
            type: Array,
            default: () => []
        },
        height: {
            type: String,
            default: '40px'
        }
    },

    computed: {
        startDate: {
            get () {
                return this.value?.[0] ? dayjs(this.value[0]).format('YYYY-MM-DD') : null
            },
            set (val) {
                this.updateDateTime(0, val, this.startTime)
            }
        },
        startTime: {
            get () {
                return this.value?.[0] ? this.$util.getHHSSDateFormat(new Date(this.value[0])) : '00:00'
            },
            set (val) {
                this.updateDateTime(0, this.startDate, val)
            }
        },
        endDate: {
            get () {
                return this.value?.[1] ? dayjs(this.value[1]).format('YYYY-MM-DD') : null
            },
            set (val) {
                this.updateDateTime(1, val, this.endTime)
            }
        },
        endTime: {
            get () {
                return this.value?.[1] ? this.$util.getHHSSDateFormat(new Date(this.value[1])) : '23:59'
            },
            set (val) {
                this.updateDateTime(1, this.endDate, val)
            }
        },
        dateTimeRangeText () {
            if (!this.value?.[0] || !this.value?.[1]) return ''
            return `${this.$util.getDDMMYYYYDateFormat(this.value[0])} ${this.startTime} ~ ${this.$util.getDDMMYYYYDateFormat(this.value[1])} ${this.endTime}`
        }
    },

    data () {
        return {
            menu: false
        }
    },

    methods: {
        updateDateTime (index, date, time) {
            if (!date || !time) return
            const newValue = [...this.value]
            newValue[index] = `${date} ${time}`
            this.$emit('input', newValue)
        },

        saveDateTimeRange () {
            this.menu = false
            this.$emit('input', [`${this.startDate} ${this.startTime}`, `${this.endDate} ${this.endTime}`])
        },

        onDateTimeRangeClear () {
            this.$emit('input', [])
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
